export const MasterDataStylingCard = {
    background: "rgba(15, 23, 42, 0.5)",
    border: "1px solid rgba(51, 65, 85, 0.3)",
    backdropFilter: "blur(12px)",
};
